<template>
  <PerfectScrollbar class="AllPwaMobile">
    <header-menu></header-menu>

    <div class="TopAllPwaMobile">
      <div class="LineTopAllPwaMobile"></div>

    
      <div class="IconLineTopAllPwaMobile">
        <div>
          <div class="ChildIconLineTopAllPwaMobile">
            <VsxIcon iconName="UserTick" :size="30" :color="color1" type="linear" />
          </div>
          <p :style="`color: ${color1}`">تایید احرازهویت</p>
        </div>

        <div v-if="BtnSvue != 2">
          <div class="ChildIconLineTopAllPwaMobile">
            <VsxIcon iconName="SecurityUser" :size="32" :color="color2" type="linear" />
          </div>
          <p :style="`color: ${color2}`">ثبت مدارک</p>
        </div>

        <div v-if="BtnSvue == 2">
          <div class="ChildIconLineTopAllPwaMobile">
            <VsxIcon iconName="SecurityUser" :size="32" :color="color2" type="linear" />
          </div>
          <p :style="`color: ${color2}`">ثبت مدارک</p>
        </div>

        <div>
          <div style="padding-top: 13px;" class="ChildIconLineTopAllPwaMobile">
            <VsxIcon iconName="UserEdit" :size="32" :color="color3" type="linear" />
          </div>
          <p :style="`color: ${color3}`">
            {{ userGet && userGet.kv === '3' ? 'ویرایش اطلاعات' : 'ثبت اطلاعات' }}
          </p>
        </div>
      </div>
    </div>

      <!-- Warning message for rejected users -->
      <div v-if="userGet && userGet.kv === '3'" class="rejected-warning">
        <div class="warning-content">
          <VsxIcon iconName="InfoCircle" :size="20" color="#dc2626" type="bold" />
          <span>درخواست قبلی شما رد شده است. لطفاً اطلاعات خود را بررسی و مجدداً ارسال کنید.</span>
        </div>
      </div>


    <div v-if="BtnSvue == 1" class="AllShowLogoInputAndLAbel">
      <form @submit.prevent="showBtnStyle">
        <div class="ShowLogoInputAndLAbel">
          <label>نام</label>
          <div class="ShowAllNavBarStatus">
            <input type="text" v-model="FName" required />
          </div>
        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>نام خانوادگی</label>
          <div class="ShowAllNavBarStatus">
            <input v-model="LName" type="text" required />
          </div>
        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>جنسیت</label>
          <div class="ShowAllNavBarStatus">
            <select v-model="gender">
              <option>آقا</option>
              <option>خانم</option>
              <option>سایر</option>
            </select>
          </div>
        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>تاریخ تولد</label>
          <div class="ShowAllNavBarStatus">
            <date-picker v-model="BirthDay" :column="1" mode="single" required />
          </div>
        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>آدرس</label>
          <div class="ShowAllNavBarStatus">
            <input v-model="address" autocomplete="off" type="text" required />
          </div>
        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>شماره شبا (به نام خود شخص)</label>
          <div class="ShowAllNavBarStatus">
            <input v-model="shabacard" autocomplete="off" type="text" required />
          </div>
        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>شماره کارت</label>
          <div class="ShowAllNavBarStatus">
            <input v-model="cardnumber" autocomplete="off" type="text" required />
          </div>
        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>کد ملی</label>
          <div class="ShowAllNavBarStatus">
            <input v-model="codeP" autocomplete="off" type="text" required />
          </div>
        </div>

        <div @click="showBtnStyle" class="ShowLogoInputAndLAbel23">
          بعدی
        </div>
      </form>
    </div>

    <div v-if="BtnSvue == 2">
      

      <div class="ShowTextBtnSave">
        <h1>عکس مدرک شناسایی همراه با متن زیر</h1>
        <p>
          لطفا متن زیر را بر روی کاغذ با خط بنویسید و به همراه کارت شناسایی ارسال نمایید.
        </p>

        <div class="ShowSimpleText">
          این جناب
          <span>{{FName}} {{LName}}</span>
          با کد ملی
          <span>{{codeP}}</span>
          این مدارک را جهت احراز هویت به شرکت داده پردازان ارسال می نمایم و همچنین متعهد می شوم با آگاهی کامل نسبت به حساب های اجاره ایی و عواقب کیفری ان , حساب کاربری و مدارک خود را در اختیار اشخاص دیگر قرار ندهم.
        </div>

        <div style="direction: rtl">
          <p>تاریخ : ...</p>
          <p>امضا : ...</p>
        </div>
      </div>

      <div style="margin-top: 30px !important;" class="ShowSelectSearch">
        <span>عکس مدرک و متن دست‌نویس را بارگذاری کنید</span>
        <input @change="onFileChange" class="InputX" type="file" accept="image/*" capture="environment" placeholder="گرفتن/بارگذاری عکس" required />

        <div class="IconDivShowSelectSearch">
          <VsxIcon iconName="Image" :size="25" type="linear" />
        </div>
      </div>

      <div style="width: 95%; margin-top: 20px" @click="CountUserShow" class="ShowLogoInputAndLAbel23">
        ثبت مدارک
      </div>
    </div>

    <menu-bar></menu-bar>
  </PerfectScrollbar>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import DatePicker from '@alireza-ab/vue3-persian-datepicker';
import axios from "@/axios";
import { toast } from "vue3-toastify";

export default {
  name: "VerifyUser",
  components: {
    PerfectScrollbar,
    DatePicker,
  },
  data() {
    return {
      FName: '',
      LName: '',
      BirthDay: '',
      address: '',
      codeP: '',
      BtnSvue: 1,
      color1: '',
      color2: '',
      color3: '',
      gender: '',
      shabacard: '',
      cardnumber: '',
      selectedFile: null,
      userGet: null,
    };
  },
  methods: {
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    showIntroAlert() {
      const isRejected = this.userGet && this.userGet.kv === '3';
      const title = isRejected ? 'ویرایش اطلاعات احراز هویت' : 'احراز هویت حساب';
      const html = `
        <div style="text-align:right;direction:rtl;line-height:1.9">
          <p>برای استفاده کامل از خدمات، لازم است احراز هویت انجام دهید.</p>
          ${isRejected
            ? '<p>درخواست قبلی شما رد شده است؛ لطفاً موارد زیر را با دقت اصلاح و دوباره ارسال کنید.</p>'
            : '<p>این صفحه به‌صورت خودکار باز شده تا فرآیند احراز هویت شما تکمیل شود.</p>'}
          <ul style="padding-right:18px;margin:8px 0">
            <li><b>مرحله ۱:</b> وارد کردن اطلاعات هویتی و بانکی.</li>
            <li><b>مرحله ۲:</b> گرفتن یا بارگذاری عکس مدرک به‌همراه متن دست‌نویس.</li>
          </ul>
          <p style="margin-top:8px">بررسی مدارک معمولاً بین ۱ تا ۲۴ ساعت زمان می‌برد.</p>
        </div>
      `;
      this.$swal.fire({
        icon: 'info',
        title,
        html,
        confirmButtonText: 'متوجه شدم',
        showCloseButton: true,
      });
    },
    showBtnStyle(){
      if (this.FName === '' && this.LName === '' && this.BirthDay === '' && this.address === '' && this.codeP === '' && this.gender === ''&& this.shabacard === ''&& this.cardnumber === '') {
        // اگر یکی از فیلدها خالی بود، پیام خطا نمایش داده می‌شود
        toast('لطفاً همه فیلدها را پر کنید.', {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      } else {
        this.BtnSvue = 2;
      }
    },
    loadTheme() {
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme == "light") {
        this.color1 = '#2E1977';
        this.color2 = '#2E1977';
        this.color3 = '#2E1977';
      } else {
        this.color = '#BB86FC';
        this.color1 = '#fff';
        this.color2 = '#fff';
        this.color3 = '#fff';
      }
    },
    async CountUserShow() {
      const userData = localStorage.getItem('user');
      if (userData) {
        this.userLis = JSON.parse(userData);
      }

      // ایجاد یک شیء FormData
      const formData = new FormData();
      formData.append('id', this.userLis.id);
      formData.append('نام', this.FName);
      formData.append('جنسیت', this.gender);
      formData.append('نام_خانوادگی', this.LName);
      formData.append('تولد', this.BirthDay);
      formData.append('آدرس', this.address);
      formData.append('کد_ملی', this.codeP);
      formData.append('شماره_شبا_(به_نام_خود_شخص)', this.shabacard);
      formData.append('شماره_کارت', this.cardnumber);
      if (this.selectedFile) {
        formData.append('عکس_کارت_ملی_/_شناسنامه_/_گواهینامه', this.selectedFile);
      }

      try {
        const response = await axios.post('/send-data-kyc', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data[0] == "error") {
          toast(response.data[1], {
            autoClose: 3000,
            position: "top-right",
            type: "success",
          });
        }

        if (response.data[0] == "success") {
          this.dataGet = response.data[1];

          // بروزرسانی وضعیت کاربر در localStorage
          const userData = localStorage.getItem('user');
          if (userData) {
            const user = JSON.parse(userData);
            user.kv = '2'; // در حال بررسی
            localStorage.setItem('user', JSON.stringify(user));

            // بروزرسانی store هم
            if (this.$store) {
              this.$store.commit('setUser', user);
            }
          }

          this.$router.push({ name: 'IndexUser' });

          const message = this.userGet && this.userGet.kv === '3'
            ? 'درخواست احرازهویت شما مجدداً ارسال شد و در حال بررسی میباشد.'
            : 'حساب شما در حال بررسی میباشد.';

          toast(message, {
            autoClose: 5000,
            position: "top-right",
            type: "success",
          });
        }

        return;
      } catch (error) {
        console.error('Error fetching user planet data:', error);
        toast('خطا در ارسال اطلاعات.', {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      }
    }
  },
  mounted() {
    // بارگذاری اطلاعات کاربر
    const userData = localStorage.getItem('user');
    if (userData) {
      this.userGet = JSON.parse(userData);
    }

    this.showIntroAlert();

    setInterval(() => {
      this.loadTheme();
    }, 100);
  }
};
</script>

<style scoped>
/* استایل‌های دلخواه */

/* Rejected warning styles */
.rejected-warning {
    background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
    border: 1px solid #fca5a5;
    border-radius: 8px;
    padding: 12px 16px;
    margin: 10px 0;
    box-shadow: 0 2px 4px rgba(220, 38, 38, 0.1);
}

.warning-content {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #dc2626;
    font-size: 14px;
    font-weight: 500;
}

.warning-content span {
    margin-right: 8px;
}
</style>